import * as Sentry from "@sentry/react";

const reportError = (err, context) => {
  if (!err) return;
  if (process.env.NODE_ENV === "production") {
    if (Sentry && Sentry.captureException) {
      try {
        if (context)
          Sentry.addBreadcrumb({
            message:
              typeof context === "string" ? context : JSON.stringify(context),
          });
      } catch (e) {
        // ignore breadcrumb errors
      }
      Sentry.captureException(err);
    }
  } else {
    // In development, surface errors to the console for easier debugging
    console.error(err);
  }
};

export default reportError;
